<template>
  <transition name="slide-menu">
    <div
      v-if="isMenuOpen"
      class="mobile-menu border-r border-border-subtle bg-[rgba(249,246,240,0.95)] backdrop-blur-md"
    >
      <div class="menu-header">
        <router-link
          to="/#header"
          class="font-interface text-base font-medium uppercase tracking-[0.2em] text-text-primary"
          @click="toggleMenu()"
        >
          SNAPSHARE
        </router-link>
      </div>

      <ul class="menu-links flex-1">
        <li v-for="link in navLinks" :key="link.url" class="menu-item">
          <SiteHeaderLink :link="link" @click="toggleMenu()" />
        </li>
      </ul>

      <div v-if="ctaLink" class="menu-cta">
        <LuxuryButton
          variant="compact"
          size="md"
          block
          :to="ctaLink.url"
          @click="toggleMenu()"
        >
          {{ ctaLink.text }}
        </LuxuryButton>
      </div>
    </div>
  </transition>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import SiteHeaderLink from './SiteHeaderLink.vue';
import LuxuryButton from '@/components/library/buttons/LuxuryButton.vue';
import { buildSiteNavigation } from '@/composables/useSiteNavigation';
import { IUserInfo } from '@/helpers/interfaces';

export default defineComponent({
  name: 'AppMenu',

  components: {
    SiteHeaderLink,
    LuxuryButton,
  },

  computed: {
    isMenuOpen(): boolean {
      return this.$store.getters['app/getMenuState'];
    },

    user(): IUserInfo | null {
      return this.$store.getters['user/getUser'];
    },

    hasActiveEvent(): boolean {
      return this.$store.getters['event/hasActiveEvent'];
    },

    navigation() {
      return buildSiteNavigation(this.user, this.hasActiveEvent);
    },

    navLinks() {
      return this.navigation.navLinks;
    },

    ctaLink() {
      return this.navigation.ctaLink;
    },
  },

  methods: {
    toggleMenu() {
      this.$store.dispatch('app/toggleMenu');
    },
  },
});
</script>

<style lang="scss" scoped>
.mobile-menu {
  position: fixed;
  top: 0;
  left: 0;
  width: calc(100% - 4rem);
  height: 100vh;
  min-height: fit-content;
  z-index: 1000;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}

.menu-links {
  list-style: none;
  padding: 0;
  margin: 0;
}

.menu-item {
  margin-bottom: 2rem;

  a {
    text-decoration: none;
  }
}

.menu-header {
  margin-bottom: 2.5rem;
}

.menu-cta {
  margin-top: auto;
  padding-top: 2rem;
}

.slide-menu-enter-active,
.slide-menu-leave-active {
  transition: transform 600ms cubic-bezier(0.4, 0, 0.2, 1);
}

.slide-menu-enter-from,
.slide-menu-leave-to {
  transform: translateX(-100%);
}
</style>
